import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { useLocation, Redirect, useHistory } from 'react-router-dom';
import { Message } from 'primereact/message';
import api from '../../../interceptor/axios';
import { Toast } from 'primereact/toast';

const ResetPassword = () => {
  const toast = useRef(null);
  const [hash, setHash] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');

  const [redirect, setRedirect] = useState(false);

  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const h = params.get('hash') || '';
    setHash(h);

    // Si no viene hash, puedes dejarlo así (usuario verá error al enviar),
    // o redirigir directamente:
    // if (!h) history.push('/login');
  }, [location.search, history]);

  const handleResetPassword = () => {


    if (!hash) {
      toast.current.show({ severity: 'error', summary: 'Error', detail: 'El enlace de reinicio no es válido o ha caducado.' });
      return;
    }

    if (!password || !password2) {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Por favor, rellene todos los campos.' });
      return;
    }


    if (password !== password2) {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Las contraseñas no coinciden.' });
      setPassword('');
      setPassword2('');
      return;
    }

    // validamos que la contraseña cumple los requisitos, que son entre 8 y 16 caracteres, al menos una mayúscula, una minúscula, un número y un carácter especial (@-_$#*)
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@\-_$#*])[A-Za-z\d@\-_$#*]{8,16}$/;
    if (!regex.test(password)) {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'La contraseña no cumple los requisitos.' });
      setPassword('');
      setPassword2('');
      return;
    }

    api
      .post(process.env.REACT_APP_REST_URL + 'resetPassword.php', {
        hash: hash,
        password: password
      })
      .then((response) => {
        if (response.data.success) {
            toast.current.show({ severity: 'success', summary: 'Éxito', detail: response.data.message || 'Contraseña actualizada correctamente.' });
          setPassword('');
          setPassword2('');
          // Opcional: redirigir a login tras éxito
          // setTimeout(() => setRedirect(true), 1200);
        } else {
            toast.current.show({ severity: 'error', summary: 'Error', detail: response.data.message || 'No se pudo actualizar la contraseña.' });
              setPassword('');
          setPassword2('');
        }
      })
      .catch((err) => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: err.message || 'Se ha producido un error al conectar con el servidor.' });
      });
  };

  if (redirect) {
    return <Redirect to="/login" />;
  }

  return (
    <>
       <Toast ref={toast} />
      <section className="sign-in-page">
        <Container>
          <Row className="justify-content-center align-items-center height-self-center">
            <Col lg="5" md="12" className="align-self-center">
              <div className="sign-user_card ">
                <div className="sign-in-page-data">
                  <div className="sign-in-from w-100 m-auto">
                    <h3 className="mb-3 text-center">Reiniciar contraseña</h3>
                    <p>Recuerda que la contraseña debe cumplir los siguientes requisitos:</p>
                    <ul>
                        <li>Debe tener entre 8 y 16 caracteres</li>
                        <li>Debe contener al menos una letra mayúscula</li>
                        <li>Debe contener al menos una letra minúscula</li>
                        <li>Debe contener al menos un número</li>
                        <li>Debe contener al menos un carácter especial: @-_$#*</li>
                    </ul>

                    {/* Si quieres mostrar el hash solo en debug:
                    <small style={{ opacity: 0.7 }}>Hash: {hash}</small>
                    */}

                    <Form className="mt-4">

                      <Form.Group>
                        <Form.Control
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          type="password"
                          className="form-control mb-0"
                          id="resetPassword"
                          placeholder="Nueva contraseña"
                          required
                        />
                      </Form.Group>

                      <Form.Group>
                        <Form.Control
                          value={password2}
                          onChange={(e) => setPassword2(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') handleResetPassword();
                          }}
                          type="password"
                          className="form-control mb-0"
                          id="resetPassword2"
                          placeholder="Repetir nueva contraseña"
                          required
                        />
                      </Form.Group>

                      <div className="sign-info">
                        <Button className="btn btn-hover btn-primary1" onClick={handleResetPassword}>
                          Cambiar contraseña
                        </Button>
                      </div>
                    </Form>

                    {/* Opcional: enlace a login */}
                    <div className="mt-3">
                      <div className="d-flex justify-content-center links">
                        <span
                          className="f-link"
                          style={{ cursor: 'pointer' }}
                          onClick={() => history.push('/login')}
                        >
                          Volver a iniciar sesión
                        </span>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ResetPassword;
